import React from 'react';
import Button from 'react-bootstrap/Button';

class Delete extends React.Component {
  render(){
    return(
      <Button close
        className="btn-primary text-center"
        onClick={()=>this.props.deleteMeme(this.props.memeId)}
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          background: 'transparent',
          border: 'none'
        }}
        >
        <span>✖︎</span>
      </Button>
    )
  }
}

export default Delete;